/**
 * Keyboard Detection Utility
 * Detects keyboard vs mouse usage and adds appropriate classes to body
 * Requirements: 15.2
 */

let isUsingKeyboard = false;
let isUsingMouse = false;

/**
 * Initialize keyboard detection
 * Adds 'using-keyboard' or 'using-mouse' class to body based on user input method
 */
export function initializeKeyboardDetection() {
  // Detect keyboard usage
  document.addEventListener('keydown', (e) => {
    // Only consider Tab key as keyboard navigation
    if (e.key === 'Tab') {
      if (!isUsingKeyboard) {
        isUsingKeyboard = true;
        isUsingMouse = false;
        document.body.classList.add('using-keyboard');
        document.body.classList.remove('using-mouse');
      }
    }
  });

  // Detect mouse usage
  document.addEventListener('mousedown', () => {
    if (!isUsingMouse) {
      isUsingMouse = true;
      isUsingKeyboard = false;
      document.body.classList.add('using-mouse');
      document.body.classList.remove('using-keyboard');
    }
  });

  // Also detect touch as mouse usage
  document.addEventListener('touchstart', () => {
    if (!isUsingMouse) {
      isUsingMouse = true;
      isUsingKeyboard = false;
      document.body.classList.add('using-mouse');
      document.body.classList.remove('using-keyboard');
    }
  });

  // Initialize with mouse mode (most common)
  document.body.classList.add('using-mouse');
}

/**
 * Check if user is currently using keyboard navigation
 */
export function isKeyboardUser(): boolean {
  return isUsingKeyboard;
}

/**
 * Check if user is currently using mouse navigation
 */
export function isMouseUser(): boolean {
  return isUsingMouse;
}
